module.exports = __webpack_public_path__ + "static/img/r_002.03ea3ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_002.jpg
// module id = cfGz
// module chunks = 1